/** The legal entity that owns and operates Lobby. One source for the footer and the legal pages. */
export const COMPANY = {
  name: 'INCOGNICODE SRL',
  form: 'a Romanian limited liability company (societate cu răspundere limitată)',
  registry: 'J40/15154/2015',
  taxId: 'RO35322165',
  address: 'Str. Sergent David Ilie nr. 2, Mansardă, Camera 1, Sector 4, București, Romania',
  email: 'hi@lobbyreply.com',
} as const

/** The one plan, excluding VAT. Must match the Stripe price behind STRIPE_PRICE_LOOKUP_KEY and PLAN_PRICE_EUR in apps/control. */
export const PLAN_PRICE_EUR = 49
export const PLAN_PRICE = `€${PLAN_PRICE_EUR}`

/** Date shown as "Last updated" on every legal page. Change it whenever a legal page changes. */
export const LEGAL_UPDATED = '4 November 2026'

export const LEGAL_LINKS = [
  { label: 'Privacy policy', href: '/privacy' },
  { label: 'Terms of service', href: '/terms' },
  { label: 'Data processing agreement', href: '/dpa' },
  { label: 'Imprint', href: '/imprint' },
] as const
